<div class="header-shell">
  <header class="app-header">
      <div class="header-brand">
          <!-- <a routerLink="/" class="brand-logo">FINBOND</a>
          <span class="brand-subtitle">Mutual Bank</span> -->

          <!-- <div *ngIf="showMemorialBanner" class="memorial-banner">
            <div class="banner-content">
              <span class="tribute-text">
                In loving memory of <strong>Steve Nortje</strong> — A dedicated designer, developer, and friend.
                His contributions live on in every line of LMS code.
              </span>
              <button (click)="closeBanner()" class="close-btn" aria-label="Dismiss">&times;</button>
            </div>
          </div> -->
      </div>

      <div class="header-context">
        <div class="user-profile py-2">
            <span class="user-role">{{ userRole }}</span>
            <span class="user-branch">{{ branchName }}</span>
        </div>
      </div>

      <div class="lms-banner-context">
        <div class="lms-banner" role="banner" *ngIf="environmentName !== 'PROD'">
          <span class="env-badge">{{ environmentName }}</span>
        </div>
      </div>
  </header>

  <div class="header-announcement" aria-live="polite">
    <app-announcement-banner></app-announcement-banner>
  </div>
</div>
